export const LIST_CHARACTER_REQUEST = 'LIST_CHARACTER_REQUEST';
export const LIST_CHARACTER_REQUEST_SUCCESS = 'LIST_CHARACTER_REQUEST_SUCCESS';
export const LIST_CHARACTER_REQUEST_FAILURE = 'LIST_CHARACTER_REQUEST_FAILURE';

export const CLEAR_CHARACTER_LIST = 'CLEAR_CHARACTER_LIST';